<div class="page-layout blank p-24" fusePerfectScrollbar>
    <h1 class="mt-5">{{title}}</h1>
    <p class="lead">De clic en el siguiente botón para ingresar al sistema</p>
    <p>
        <button id="btn-login" mat-raised-button color="accent" (click)="login()">
            Ingresar 
            <mat-icon class="ml-8">verified_user</mat-icon>
        </button>
    </p>
</div>
